import { render, staticRenderFns } from "./IntegrationFormOpsgenie.vue?vue&type=template&id=4cc217c7&scoped=true"
import script from "./IntegrationFormOpsgenie.vue?vue&type=script&lang=js"
export * from "./IntegrationFormOpsgenie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc217c7",
  null
  
)

export default component.exports